import React from "react";
import { ParcelBookingTicket } from "./components";
import SoftSignupPrompt from "../../account/components/SoftSignupPrompt";

const BookingSummaryStep = () => {
  return (
    <div className="p-5">
      <ParcelBookingTicket />
      <SoftSignupPrompt />
    </div>
  );
};

export default BookingSummaryStep;
